import { FC } from 'react';
import {
	TControlProps,
	useCalendarDatepicker,
} from 'shared/lib/selectCalendar';
import { components } from 'react-select';

export const SelectControl: FC<TControlProps> = props => {
	const { children, innerProps } = props;
	const { toggleCalendarMenu } = useCalendarDatepicker();
	return (
		<components.Control
			{...props}
			innerProps={{ ...innerProps, onClick: !window.matchMedia("(pointer: coarse)").matches ? toggleCalendarMenu : undefined, onTouchStart: toggleCalendarMenu }}
		>
			{children}
		</components.Control>
	);
};
